import {FaBell, FaBellSlash} from 'react-icons/fa';
import {useChat} from '../ChatProvider';

const LABELS = {
    checking: 'Checking notifications…',
    prompt: 'Enable notifications',
    enabled: 'Chat notifications enabled',
    blocked: 'Notifications blocked by browser',
    error: 'Retry notification setup',
};

export default function ChatNotificationButton() {
    const {notifications} = useChat();
    if (!notifications || ['unsupported', 'unavailable'].includes(notifications.status)) return null;
    const enabled = notifications.status === 'enabled';
    const blocked = notifications.status === 'blocked';
    const checking = notifications.status === 'checking';
    const label = LABELS[notifications.status] || 'Enable notifications';

    return (
        <button
            type="button"
            className={`chat-notification-toggle${enabled ? ' is-enabled' : ''}`}
            aria-label={label}
            title={notifications.error?.message || label}
            disabled={checking || blocked}
            onClick={() => enabled ? notifications.disable() : notifications.enable()}
        >
            {blocked ? <FaBellSlash aria-hidden="true" /> : <FaBell aria-hidden="true" />}
            <span>{enabled ? 'Notifications on' : blocked ? 'Notifications blocked' : 'Enable notifications'}</span>
        </button>
    );
}
